import axios from "axios";


import config from "../../../../config";

const API_URL = config.TRAFFIC;

export async function fetchInfoHubChartData(endpoint) {
  try {
    const response = await axios.get(
      `${API_URL}${endpoint}`,
      { headers: { "Accept-Profile": "infohub" } }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching route events:", error);
    return [];
  }
}
